import { Math } from '../context'
const nativeMin = Math.min
export default nativeMin
